export const GET_ALL_STATIC_PAGES = 'GET_ALL_STATIC_PAGES'
export const GET_SINGLE_STATIC_PAGE = 'GET_SINGLE_STATIC_PAGE'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_BID_INCREMENTS = 'GET_ALL_BID_INCREMENTS'
export const GET_ALL_TABLE_VALUES = 'GET_ALL_TABLE_VALUES'
export const GET_SINGLE_BID_INCREMENT = 'GET_SINGLE_BID_INCREMENT'
export const SEARCH_TABLE = 'SEARCH_TABLE'
